import { render, staticRenderFns } from "./lawsDetail.vue?vue&type=template&id=52eb1362&scoped=true"
import script from "./lawsDetail.vue?vue&type=script&lang=js"
export * from "./lawsDetail.vue?vue&type=script&lang=js"
import style0 from "./lawsDetail.vue?vue&type=style&index=0&id=52eb1362&prod&lang=scss&scoped=true"
import style1 from "./lawsDetail.vue?vue&type=style&index=1&id=52eb1362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb1362",
  null
  
)

export default component.exports